import { motion } from 'framer-motion';

export const TopNav = ({ tabs, activeTab, onSelect, accent, accentFg }) => (
  <div
    role="tablist"
    data-testid="top-nav"
    className="hidden md:inline-flex items-center gap-1 rounded-full border border-white/[0.06] bg-[#18181b] p-1"
  >
    {tabs.map((tab) => {
      const Icon = tab.icon;
      const active = activeTab === tab.value;
      return (
        <button
          key={tab.value}
          type="button"
          role="tab"
          aria-selected={active}
          data-testid={`${tab.value}-tab`}
          onClick={() => (tab.action ? tab.action() : onSelect(tab.value))}
          className={`relative flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
            active ? accentFg : 'text-[#a1a1aa] hover:text-white'
          }`}
        >
          {active && (
            <motion.span
              layoutId="top-nav-pill"
              transition={{ type: 'spring', stiffness: 500, damping: 40 }}
              className="absolute inset-0 rounded-full"
              style={{ backgroundColor: accent }}
            />
          )}
          <Icon className="relative h-4 w-4" />
          <span className="relative">{tab.label}</span>
          {tab.badge > 0 && (
            <span
              className={`relative flex h-5 min-w-[20px] items-center justify-center rounded-full px-1.5 text-[11px] font-bold ${
                active ? 'bg-black/20' : 'text-black'
              }`}
              style={active ? undefined : { backgroundColor: accent }}
            >
              {tab.badge}
            </span>
          )}
        </button>
      );
    })}
  </div>
);
